import {useSelector} from 'react-redux'
import LoginGetUsernamePassword from '../components/LoginGetUsernamePassword'
import LoginSubmitCode from '../components/LoginSubmitCode'

const Login = ({view} : {view: 'company' | 'talent'}) => {
  const currentUser = useSelector((state: any) => state.currentUser)
  const {isAuthCodeCreated} = currentUser
  
  return (
    <>
      {!isAuthCodeCreated && (
        <LoginGetUsernamePassword view={view} />
      )}
      {isAuthCodeCreated && (
        <LoginSubmitCode view={view} />
      )}
    </>
  );
};

export default Login;
